import store from '@/store';

const hasPermission = (
  permission: string | string[],
  environment: string | string[] = '',
  isInternal: number | undefined = undefined,
) => {
  let isValidEnv = true;

  const isValidUser = isInternal !== undefined && isInternal !== null
    ? isInternal === store.state.user?.user.is_internal : true;

  if (environment) {
    if (typeof environment === 'string') {
      isValidEnv = process.env.VUE_APP_ENVIRONMENT === environment;
    }
    isValidEnv = environment.includes((process.env.VUE_APP_ENVIRONMENT || '').toString());
  }

  if (permission === undefined) {
    return true && isValidEnv && isValidUser;
  }

  if (typeof permission === 'string') {
    return store.state.user?.permission.includes(permission) && isValidEnv && isValidUser;
  }

  return store.state.user?.permission.some((e) => permission.includes(e)) && isValidEnv && isValidUser;
};

export default hasPermission;
